import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const searchIcon = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="11" cy="11" r="6" stroke="#ffffff" stroke-width="2"/>
  <path d="M16 16L20 20" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/>
  </svg>`
);
